import { ChevronsRight } from 'lucide-react';
import cn from 'classnames';

interface InfoBoxProps {
  /** 子内容 */
  children: React.ReactNode;
  /** 自定义类名 */
  className?: string;
}

/**
 * 信息框组件（灰色背景）
 */
export function InfoBox({ children, className }: InfoBoxProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-[16px] rounded-[8px] bg-[#f5f5f5] p-[16px]',
        'text-[14px] font-normal leading-[1.5] tracking-[0.07px] text-[#262626]',
        className
      )}
    >
      {children}
    </div>
  );
}

interface InfoBoxTitleProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * 信息框标题
 */
export function InfoBoxTitle({ children, className }: InfoBoxTitleProps) {
  return <p className={cn('text-[16px] font-medium leading-[1.5] text-[#262626]', className)}>{children}</p>;
}

interface InfoBoxListProps {
  items: string[];
  className?: string;
}

/**
 * 信息框列表（带双箭头图标）
 */
export function InfoBoxList({ items, className }: InfoBoxListProps) {
  return (
    <div className={cn('flex flex-col gap-[8px]', className)}>
      {items.map((item, index) => (
        <div key={index} className="flex items-start gap-[8px]">
          <ChevronsRight className="mt-[2px] h-[16px] w-[16px] shrink-0 text-[#262626]" />
          <span className="flex-1 text-[14px] font-normal leading-[1.5] tracking-[0.07px] text-[#262626]">{item}</span>
        </div>
      ))}
    </div>
  );
}

export default InfoBox;
